'use client';
import { CHECKOUT_REFERENCE_RE, type CheckoutClientEvent } from './checkout-trace';
import { trackPostHogEvent } from '@/lib/analytics/posthog';

export function recordCheckoutObservation(orderId: string | null, type: CheckoutClientEvent): void {
  if (!orderId || !CHECKOUT_REFERENCE_RE.test(orderId) || !globalThis.crypto?.randomUUID) return;
  const body = JSON.stringify({ id: crypto.randomUUID(), type });
  const send = () => fetch(`/api/tours/checkout-orders/${orderId}/events`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true,
  });
  // La BD conserva la huella aunque PostHog esté bloqueado. El reintento conserva el ID.
  void send().then(r => { if (r.status >= 500) throw new Error('trace unavailable'); })
    .catch(() => { setTimeout(() => { void send().catch(() => {}); }, 1000); });
  trackPostHogEvent('checkout_observation', { order_id: orderId, observation: type, source: 'browser' });
}
